import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiService } from '../services/apiService';

const BASE_URL = 'https://admin.defconinnovations.com/crmapi';
const endpoint = '/GetCustomer/';

export const useClients = () => {
  const queryClient = useQueryClient();

  const user = JSON.parse(localStorage.getItem('user'));
  const orgId = user?.org;

  if (!orgId) throw new Error('Organization ID not found');

  const org = `?org=${orgId}`;

  const useGetClients = () =>
    useQuery({
      queryKey: ['clients', orgId], // include orgId in key for isolation
      queryFn: () => apiService.get(BASE_URL, `${endpoint}${org}`),
      enabled: typeof window !== 'undefined',
    });

  const useAddClient = () =>
    useMutation({
      mutationFn: data =>
        apiService.post(BASE_URL, `${endpoint}${org}`, {
          ...data,
          org: orgId,
        }),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['clients', orgId] });
      },
    });

  const useUpdateClient = () =>
    useMutation({
      mutationFn: ({ id, data }) =>
        apiService.patch(BASE_URL, `${endpoint}${id}/${org}`, {
          ...data,
          org: orgId,
        }),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['clients', orgId] });
      },
    });

  const useDeleteClient = () =>
    useMutation({
      mutationFn: id =>
        apiService.patch(BASE_URL, `${endpoint}${id}/${org}`, {
          is_archive: true,
          org: orgId,
        }),
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['clients', orgId] });
      },
    });

  return {
    useGetClients,
    useAddClient,
    useUpdateClient,
    useDeleteClient,
  };
};
